/* global embeddedservice_bootstrap */
import React, { useEffect } from 'react';
import './LiveChat.css';

// ---------------------------------------------------------------------------
// Salesforce Embedded Messaging for Web (MIAW / bootstrap SDK)
// Replaces the legacy ESW 5.0 / LiveAgent integration.
//
// SANDBOX values — replace with production equivalents before go-live:
//   ORG_ID, DEPLOYMENT_NAME, SITE_URL, SCRT2_URL, BOOTSTRAP_URL
//
// TODO: Confirm with Salesforce team how to pass user identity data
//       (window.chatUser) in the new SDK — options are:
//         a) embeddedservice_bootstrap.userVerificationAPI (signed JWT)
//         b) embeddedservice_bootstrap.prechatAPI.setHiddenPrechatFields()
//       Update the TODO block inside initEmbeddedMessaging() once confirmed.
// ---------------------------------------------------------------------------

const SALESFORCE_ORG_ID =
    process.env.REACT_APP_SF_EMBEDDED_MESSAGING_ORG_ID || '00DOu00000Cillt';
const SALESFORCE_DEPLOYMENT_NAME =
    process.env.REACT_APP_SF_EMBEDDED_MESSAGING_DEPLOYMENT || 'COV_Provider_Portal_Enhanced';
const SALESFORCE_SITE_URL =
    process.env.REACT_APP_SF_EMBEDDED_MESSAGING_SITE_URL ||
    'https://mitchell--test.sandbox.my.site.com/ESWCOVProviderPortalEn1772559640915';
const SALESFORCE_SCRT2_URL =
    process.env.REACT_APP_SF_EMBEDDED_MESSAGING_SCRT2_URL ||
    'https://mitchell--test.sandbox.my.salesforce-scrt.com';
const SALESFORCE_BOOTSTRAP_URL =
    process.env.REACT_APP_SF_EMBEDDED_MESSAGING_BOOTSTRAP_URL || `${SALESFORCE_SITE_URL}/assets/js/bootstrap.min.js`;


function initEmbeddedMessaging() {
    try {
        embeddedservice_bootstrap.settings.language = 'en_US';

        // TODO: Pass logged-in user data once Salesforce team confirms the
        // supported approach for COV_Provider_Portal_Enhanced.
        // Example (hidden pre-chat fields — confirm API with SF team):
        //
        // embeddedservice_bootstrap.prechatAPI.setHiddenPrechatFields({
        //     FirstName: window.chatUser?.userFirstName,
        //     LastName:  window.chatUser?.userLastName,
        //     Email:     window.chatUser?.emailAddr,
        //     Phone:     window.chatUser?.phoneNum,
        //     Type:      window.chatUser?.typeCd,
        // });

        embeddedservice_bootstrap.init(
            SALESFORCE_ORG_ID,
            SALESFORCE_DEPLOYMENT_NAME,
            SALESFORCE_SITE_URL,
            {
                scrt2URL: SALESFORCE_SCRT2_URL
            }
        );
    } catch (err) {
        console.error('Error loading Embedded Messaging: ', err);
    }
}

function loadBootstrapScript(onLoaded) {
    const scriptElement = document.createElement('script');
    scriptElement.setAttribute('src', SALESFORCE_BOOTSTRAP_URL);
    scriptElement.onload = onLoaded;
    scriptElement.onerror = (event) => {
        console.error(
            'Failed to load Salesforce Embedded Messaging bootstrap script.\n' +
            `URL attempted: ${SALESFORCE_BOOTSTRAP_URL}\n`,
            event
        );
    };
    document.body.appendChild(scriptElement);
}

export default function LiveChat(props) {

    useEffect(() => {
        if (typeof embeddedservice_bootstrap !== 'undefined') {
            // Bootstrap script was already loaded (e.g. hot-reload)
            initEmbeddedMessaging();
        } else {
            loadBootstrapScript(initEmbeddedMessaging);
        }
    }, []);

    return (
        <div className='LiveChat' style={{ display: 'inline-block' }}>
        </div>
    );
}